import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import PlaybookForm from "./PlaybookForm";

const PlaybookModal = ({ toggle, isOpen, clientId, razonSocial, refreshData, dataToEdit }) => {
  return (
    <div style={{ fontFamily: "Nunito" }}>
      <Modal centered size="lg" isOpen={isOpen}>
        <ModalHeader toggle={toggle}>Nuevo Playbook</ModalHeader>
        <ModalBody style={{ backgroundColor: "#f8f8f8", borderRadius: "10px" }}>
          <PlaybookForm clientId={clientId} toggle={toggle} razonSocial={razonSocial} refreshData={refreshData} dataToEdit={dataToEdit} />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default PlaybookModal;
